(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[527],{

/***/ 97071:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "H": function() { return /* binding */ PDFIcon; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(4730);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(32125);
// EXTERNAL MODULE: ./src/styles/theme.ts
var theme = __webpack_require__(49642);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./src/components/elements/Icon/PDF/pdf.svg
var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgPdf = function SvgPdf(props) {
  return /*#__PURE__*/react.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 24"
  }, props), _g || (_g = /*#__PURE__*/react.createElement("g", {
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 1777"
  }, /*#__PURE__*/react.createElement("path", {
    "data-name": "\\u30D1\\u30B9 1540",
    d: "M5.963 5.234V.291L.278 5.976h4.943c.534 0 .742-.208.742-.742Z"
  }), /*#__PURE__*/react.createElement("path", {
    "data-name": "\\u30D1\\u30B9 1541",
    d: "M8.819 11.945a8.259 8.259 0 0 0 .414-1.759c.207-1.008-.052-1.629-.594-1.55s-.672.7-.62 1.344a5.342 5.342 0 0 0 .594 1.784s.1.258.206.181Z"
  }), /*#__PURE__*/react.createElement("path", {
    "data-name": "\\u30D1\\u30B9 1542",
    d: "M6.339 17.118a5.839 5.839 0 0 0-2.041 1.086c-.7.673-.648 1.267-.336 1.473s1.189-.414 1.732-1.06a5.145 5.145 0 0 0 .9-1.4c.004-.099-.047-.177-.255-.099Z"
  }), /*#__PURE__*/react.createElement("path", {
    "data-name": "\\u30D1\\u30B9 1543",
    d: "M8.214 16.028c.515-.206 2.377-.621 2.377-.621s-1.214-1.447-1.37-1.732c0 .001-.724 1.888-1.007 2.353Z"
  }), /*#__PURE__*/react.createElement("path", {
    "data-name": "\\u30D1\\u30B9 1544",
    d: "M17.051 0H6.97v5.864a1.171 1.171 0 0 1-1.164 1.174H0v16a.955.955 0 0 0 .949.957h16.1a.954.954 0 0 0 .949-.957V.956A.954.954 0 0 0 17.051 0Zm-3.106 17.849a7.087 7.087 0 0 1-2.917-1.886.23.23 0 0 0-.069-.015c-.15 0-1.82.485-3.088.848-1.854 3.341-3.7 4.294-4.567 3.189-.456-.582-.28-1.955 1.914-2.984a14.164 14.164 0 0 1 1.77-.668 31.5 31.5 0 0 0 1.573-3.579 10.185 10.185 0 0 1-1.072-2.772c-.1-1.081.357-2.059 1.276-2.059 1.171 0 2.04 1.132.668 5.111a12.589 12.589 0 0 0 1.673 2.246 13.561 13.561 0 0 1 2.784-.261c1.651.1 1.994.877 2.045 1.469a1.6 1.6 0 0 1-1.99 1.361Z"
  }), /*#__PURE__*/react.createElement("path", {
    "data-name": "\\u30D1\\u30B9 1545",
    d: "M13.761 15.555a6.219 6.219 0 0 0-2.069.258 6.871 6.871 0 0 0 2.093 1.035c.777.1 1.062-.232 1.062-.568s-.284-.673-1.086-.725Z"
  }))));
};
/* harmony default export */ var pdf = (SvgPdf);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/elements/Icon/PDF/index.tsx


var _excluded = ["size"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }





var PDFIcon = function PDFIcon(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'regular' : _ref$size,
      props = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded);

  return /*#__PURE__*/(0,jsx_runtime.jsx)(StyledIcon, _objectSpread(_objectSpread({}, props), {}, {
    "data-size": size
  }));
};
var StyledIcon = (0,styled_components_browser_esm/* default */.ZP)(pdf).withConfig({
  displayName: "PDF__StyledIcon",
  componentId: "sc-18bayee-0"
})(["transition:fill 0.3s ease;fill:", ";&[data-size='regular']{width:18px;height:24px;}&[data-size='small']{width:12px;height:28px;}"], theme/* theme.colors.trialBlue */.r.colors.trialBlue);

/***/ }),

/***/ 24604:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "G": function() { return /* binding */ PDFItem; }
/* harmony export */ });
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(32125);
/* harmony import */ var _styles_theme__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(49642);
/* harmony import */ var _utils_date__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(16645);
/* harmony import */ var _components_elements_Icon_PDF__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(97071);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);






var PDFItem = function PDFItem(_ref) {
  var date = _ref.date,
      fileName = _ref.fileName,
      filePath = _ref.filePath;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)(StyledLink, {
    href: filePath,
    target: "_blank",
    rel: "noreferrer noopener",
    children: [date && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(Time, {
      dateTime: date,
      children: (0,_utils_date__WEBPACK_IMPORTED_MODULE_3__/* .formatDate */ .p6)(date, 'yyyy/MM/dd')
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(Icon, {
      size: "small"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(Name, {
      children: fileName
    })]
  });
};
var Time = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].time.withConfig */ .ZP.time.withConfig({
  displayName: "PDFItem__Time",
  componentId: "sc-12039hs-0"
})(["font-weight:700;line-height:1.6;"]);
var StyledLink = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].a.withConfig */ .ZP.a.withConfig({
  displayName: "PDFItem__StyledLink",
  componentId: "sc-12039hs-1"
})(["transition:color 0.3s ease;display:flex;align-items:center;gap:10px;padding-top:18px;padding-bottom:20px;width:100%;&:hover{> span{color:", ";text-decoration:underline;}> svg{fill:", ";}}"], _styles_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.colors.lightBlue */ .r.colors.lightBlue, _styles_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.colors.lightBlue */ .r.colors.lightBlue);
var Name = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].span.withConfig */ .ZP.span.withConfig({
  displayName: "PDFItem__Name",
  componentId: "sc-12039hs-2"
})(["line-height:1.6;"]);
var Icon = (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)(_components_elements_Icon_PDF__WEBPACK_IMPORTED_MODULE_1__/* .PDFIcon */ .H).withConfig({
  displayName: "PDFItem__Icon",
  componentId: "sc-12039hs-3"
})(["flex-shrink:0;"]);

/***/ }),

/***/ 50267:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* reexport */ BasicsPage; }
});

// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(32125);
// EXTERNAL MODULE: ./src/components/elements/SectionTitle/index.tsx
var SectionTitle = __webpack_require__(70770);
// EXTERNAL MODULE: ./src/components/elements/Spacer/index.tsx
var Spacer = __webpack_require__(1253);
// EXTERNAL MODULE: ./src/components/layout.tsx + 7 modules
var layout = __webpack_require__(55548);
// EXTERNAL MODULE: ./src/components/layouts/Head/index.tsx
var Head = __webpack_require__(22978);
// EXTERNAL MODULE: ./src/components/layouts/Ir/index.tsx
var Ir = __webpack_require__(87661);
// EXTERNAL MODULE: ./src/components/layouts/Ir/Paragraph.tsx
var Paragraph = __webpack_require__(45775);
// EXTERNAL MODULE: ./src/components/layouts/Ir/PDFItem.tsx
var PDFItem = __webpack_require__(24604);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/pages/Ir/Governance/Basics/index.tsx











var BasicsPage = function BasicsPage() {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(Ir/* Layout */.A, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(SectionTitle/* SectionTitle */.N, {
      color: "normal",
      titleText: "Basic Policy",
      subTitleText: "\u30B3\u30FC\u30DD\u30EC\u30FC\u30C8\u30FB\u30AC\u30D0\u30CA\u30F3\u30B9\u306B\u95A2\u3059\u308B\u57FA\u672C\u7684\u306A\u8003\u3048\u65B9"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Spacer/* Spacer */.L, {
      h: {
        sp: 70,
        pc: 120
      }
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Paragraph/* Paragraph */.n, {
      children: "\u5F53\u793E\u306F\u3001\u304A\u5BA2\u69D8\u306E\u5F79\u306B\u7ACB\u3064\u305F\u3081\u306B\u3001\u6D41\u901A\u5C0F\u58F2\u696D\u754C\u306B\u304A\u3051\u308B\u300E\u30E0\u30C0\u30FB\u30E0\u30E9\u30FB\u30E0\u30EA\u300F\u3092\u306A\u304F\u3059\u3053\u3068\u304C\u3001\u793E\u4F1A\u306E\u8AB2\u984C\u89E3\u6C7A\u306B\u3064\u306A\u304C\u308B\u3068\u8003\u3048\u3066\u304A\u308A\u3001\u300E\u4E16\u754C\u306E\u8AB0\u3082\u304C\u300C\u8C4A\u304B\u3055\u300D\u3092\u4EAB\u53D7\u3067\u304D\u308B\u793E\u4F1A\u3092\u3064\u304F\u308B\u3002\u300F\u3092\u5F53\u793E\u30B0\u30EB\u30FC\u30D7\u306E\u30D1\u30FC\u30D1\u30B9\u3068\u3057\u3066\u304A\u308A\u307E\u3059\u3002 \u307E\u305F\u3001\u682A\u4E3B\u30FB\u6295\u8CC7\u5BB6\u3092\u542B\u3080\u30B9\u30C6\u30FC\u30AF\u30DB\u30EB\u30C0\u30FC\u306E\u7686\u69D8\u3068\u5354\u50CD\u3059\u308B\u3053\u3068\u304C\u3001\u4F01\u696D\u3068\u3057\u3066\u306E\u6301\u7D9A\u7684\u306A\u6210\u9577\u3068\u4F01\u696D\u4FA1\u5024\u5411\u4E0A\u306E\u5B9F\u73FE\u306B\u3064\u306A\u304C\u308B\u3068\u8003\u3048\u3066\u304A\u308A\u307E\u3059\u3002\u305D\u306E\u305F\u3081\u306B\u306F\u3001\u30B3\u30F3\u30D7\u30E9\u30A4\u30A2\u30F3\u30B9\u306E\u5FB9\u5E95\u3001\u7D4C\u55B6\u306E\u900F\u660E\u6027\u306E\u78BA\u4FDD\u3068\u3068\u3082\u306B\u3001\u8FC5\u901F\u306A\u610F\u601D\u6C7A\u5B9A\u306B\u3088\u308B\u30B9\u30D4\u30FC\u30C9\u7D4C\u55B6\u306E\u5B9F\u73FE\u304C\u91CD\u8981\u3067\u3042\u308A\u3001\u305D\u306E\u4ED5\u7D44\u307F\u3092\u69CB\u7BC9\u3057\u3001\u6A5F\u80FD\u3055\u305B\u308B\u3053\u3068\u304C\u30B3\u30FC\u30DD\u30EC\u30FC\u30C8\u30FB\u30AC\u30D0\u30CA\u30F3\u30B9\u306E\u57FA\u672C\u7684\u306A\u8003\u3048\u65B9\u3068\u306A\u308A\u307E\u3059\u3002\u3053\u306E\u57FA\u672C\u7684\u306A\u8003\u3048\u65B9\u306B\u57FA\u3065\u304D\u3001\u30B3\u30FC\u30DD\u30EC\u30FC\u30C8\u30FB\u30AC\u30D0\u30CA\u30F3\u30B9\u306E\u7D99\u7D9A\u7684\u306A\u9032\u5316\u3068\u5145\u5B9F\u306B\u53D6\u308A\u7D44\u307F\u307E\u3059\u3002"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Spacer/* Spacer */.L, {
      h: {
        sp: 30,
        pc: 30
      }
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(PDFItem/* PDFItem */.G, {
      fileName: "\u30B3\u30FC\u30DD\u30EC\u30FC\u30C8\u30FB\u30AC\u30D0\u30CA\u30F3\u30B9\u306B\u95A2\u3059\u308B\u5831\u544A\u66F8",
      filePath: "https://storage.googleapis.com/p_62df6d7ecf43187b7e0b68b2/b22d89e6-41c2-4fdb-959f-596c69a0d0a4/TRIAL_CorporateGovernanceReport_260929.pdf"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Spacer/* Spacer */.L, {
      h: {
        sp: 20,
        pc: 30
      }
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(PublishDate, {
      children: "2026\u5E749\u670829\u65E5"
    })]
  });
};

BasicsPage.getLayout = function (page) {
  var breadCrumbs = [{
    name: 'ホーム',
    path: '/'
  }, {
    name: '株主・投資家向け情報',
    path: '/ir/'
  }, {
    name: 'コーポレート・ガバナンス',
    path: '/ir/governance/'
  }, {
    name: 'コーポレート・ガバナンスに関する基本的な考え方',
    path: ''
  }];
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Head/* Head */.F, {
      title: "\u30B3\u30FC\u30DD\u30EC\u30FC\u30C8\u30FB\u30AC\u30D0\u30CA\u30F3\u30B9\u306B\u95A2\u3059\u308B\u57FA\u672C\u7684\u306A\u8003\u3048\u65B9",
      description: "\u30C8\u30E9\u30A4\u30A2\u30EB\u30DB\u30FC\u30EB\u30C7\u30A3\u30F3\u30B0\u30B9\u306E\u30B3\u30FC\u30DD\u30EC\u30FC\u30C8\u30FB\u30AC\u30D0\u30CA\u30F3\u30B9\u306B\u95A2\u3059\u308B\u57FA\u672C\u7684\u306A\u8003\u3048\u65B9\u306B\u3064\u3044\u3066\u63B2\u8F09\u3057\u3066\u3044\u307E\u3059\u3002",
      ogp: {
        url: '/ir/governance/basics'
      }
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(layout/* TitleLayout */.$0, {
      title: "Investor Relations",
      subTitle: "\u682A\u4E3B\u30FB\u6295\u8CC7\u5BB6\u5411\u3051\u60C5\u5831",
      breadCrumbs: breadCrumbs,
      children: page
    })]
  });
};

var PublishDate = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "Basics__PublishDate",
  componentId: "sc-tnytln-0"
})(["display:flex;justify-content:flex-end;"]);
;// CONCATENATED MODULE: ./src/pages/ir/governance/basics.tsx


/***/ }),

/***/ 16645:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "bp": function() { return /* binding */ isEqualYear; },
/* harmony export */   "dG": function() { return /* binding */ isEqualMonth; },
/* harmony export */   "p6": function() { return /* binding */ formatDate; }
/* harmony export */ });
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(72167);

var formatDate = function formatDate(date, formatType) {
  try {
    return (0,date_fns__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(new Date(date), formatType);
  } catch (e) {
    return date;
  }
};
var isEqualYear = function isEqualYear(date, year) {
  return formatDate(date, 'yyyy') === year;
};
var isEqualMonth = function isEqualMonth(date, month) {
  return formatDate(date, 'M') === month;
};

/***/ }),

/***/ 43627:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ir/governance/basics",
      function () {
        return __webpack_require__(50267);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [1228,3874,2768,2167,5548,4535,9774,2888,179], function() { return __webpack_exec__(43627); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);